module.exports = __webpack_public_path__ + "static/media/dotauditIcon.597c29c3.svg";